<template>
  <div>
    <my-table :title="title"
              :searchParams="searchParams"
              :isAdd="isAdd"
              :tableData="tableData"
              @pageNumChange="pageNumChange"
              @search="search"
              @keyup.enter.native="keyup()" @add="addMerchants">
      <div slot="table">
        <sku-info-table :tableData="tableData.list" @del="del"></sku-info-table>
      </div>
    </my-table>
  </div>
</template>

<script>
  import SkuInfoTable from "./SkuInfoTable";
  import MyTable from "../../components/content/myTable/MyTable";
  import {getSkuInfoList,newVue,delSkuInfoBySkuId} from "../../network/skuInfo";

  export default {
    name: "skuInfoList",
    components: {SkuInfoTable, MyTable},
    data(){
      return {
        title: "商品列表",
        //搜索条件
        searchParams:[
          {
            key:"skuNo",
            value:"商品编号"
          },
          {
            key:"skuClassifyId",
            value:"商品分类",
            isSelect:[
              {
                key:"心选农产",
                value:"心选农产"
              },
              {
                key:"渔产干货",
                value:"渔产干货"
              }
            ]
          },
          {
            key:"activityClassify",
            value:"商品活动类型",
            isSelect:[
              {
                key:"普通商品",
                value:"普通商品"
              },
              {
                key:"拼团商品",
                value:"拼团商品"
              },
              {
                key:"秒购商品",
                value:"秒购商品"
              }
            ]
          },
          {
            key:"specialClassify",
            value:"商品特殊分类",
            isSelect:[
              {
                key:"坞栈商品",
                value:"坞栈商品"
              }
            ]
          },
          {
            key:"merchantsName",
            value:"所属农基商"
          },
          {
            key:"skuName",
            value:"商品名称"
          },
          {
            key:"isShelves",
            value:"商品状态",
            isSelect:[
              {
                key:"0",
                value:"0"
              },
              {
                key:"1",
                value:"1"
              },
              {
                key:"2",
                value:"2"
              }
            ]
          }
        ],
        isAdd: true,
        tableData:{},
        searchItems:{}
      }
    },
    created() {
      newVue.obj = this;
      this.common.HeaderLocationTwo.href = "/pmsSkuInfo/list";
      this.common.HeaderLocationTwo.name = "农商品管理";
      this.common.HeaderLocationThree.name = "农商品列表"
      getSkuInfoList().then(res => {
        this.tableData = res.data
      })
    },
    methods:{
      pageNumChange(pageNum){
        this.searchEasy(this.searchItems,pageNum);
      },
      search(searchItems){
        this.searchItems = searchItems;
        this.searchEasy(searchItems)
      },
      searchEasy(searchItems,pageNum){
        let skuNo = null;
        let merchantsName = null;
        let activityClassify = null;
        let specialClassify = null;
        let skuClassifyId = null;
        let skuName = null;
        let isShelves = null;
        let labelValue = null;
        for (let i = 0;i<searchItems.length;i++){
          if (searchItems[i].value === "skuNo"){
            skuNo = searchItems[i].input
          }else if (searchItems[i].value === "merchantsName"){
            merchantsName = searchItems[i].input
          }else if (searchItems[i].value === "skuClassifyName"){
            skuClassifyId = searchItems[i].input
          }else if (searchItems[i].value === "activityClassify"){
            activityClassify = searchItems[i].input
          }else if (searchItems[i].value === "specialClassify"){
            specialClassify = searchItems[i].input
          }else if (searchItems[i].value === "skuName"){
            skuName = searchItems[i].input
          }else if (searchItems[i].value === "isShelves"){
            if (searchItems[i].input!=="0"&&searchItems[i].input!=="1"&&searchItems[i].input!=="2"){
              this.$message({
                type: 'error',
                message: '该类型不存在，请填入合适的类型，0表示上架，1表示下架，2表示封仓'
              });
              return;
            }
            isShelves = searchItems[i].input
          }else if (searchItems[i].value === "labelValue"){
            labelValue = searchItems[i].input
          }
        }
        getSkuInfoList(skuNo,merchantsName,skuClassifyId,skuName,isShelves,labelValue,activityClassify,specialClassify,pageNum).then(res => {
          this.tableData = res.data
        })
      },
      keyup(){
        this.searchEasy(this.searchItems);
      },
      del(id){
        delSkuInfoBySkuId(id).then(res => {
            this.searchEasy(this.searchItems);
          }
        )
      },
      addMerchants(){
        this.$router.push("insert/")
      }
    }
  }
</script>

<style scoped>

</style>
